// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__clS_g","cell":"ColumnAccessor_cell__3vP5u","firstCellAccent":"ColumnAccessor_firstCellAccent__1ojB1"};